// initial state

export const consts = {
  // 布尔值
  FALSE: 0,
  TRUE: 1,

  // 是否通用
  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  // 激活状态
  STATUS_NEW: 1,
  // 如要修改，请同步修改training-course.constants.js中的KNOWLEDGE_STATUS_ACTIVE常量
  STATUS_ACTIVE: 2,
  STATUS_BANNED: 3,
}
export const options = {
  IsCommonStatus: [
    {value: consts.IS_COMMON_SHARED, label: '通用'},
    {value: consts.IS_COMMON_DEDICATED, label: '专用'}
  ],
  KnowledgeStatus: [
    {value: consts.STATUS_ACTIVE, label: '已激活'},
    {value: consts.STATUS_BANNED, label: '已作废'}
  ],
  KnowledgeStatusTable: [
    {value: consts.STATUS_NEW, label: '新创建'},
    {value: consts.STATUS_ACTIVE, label: '已激活'},
    {value: consts.STATUS_BANNED, label: '已作废'}
  ]
}

export function isKnowledgeDialogEditLocked (id, status) {
  return Number(id) > 0 && Number(status) !== consts.STATUS_NEW
}



// WEBPACK FOOTER //
// ./src/views/training/training-knowledge.constants.js